import { Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
import TickIcon from "../../Common/Svgs/TickIcon";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";

const SelectionDropdown = ({
  type = "batteries",
  error = "",
  value,
  data,
  onSelect,
  searchKey = "name",
  placeholder = "Select",
  width = "",
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const inputRef = useRef(null);

  const hasError = error || null;

  const getValueStyle = () => {
    if (type === "hub")
      return "h-9 w-[312px] bg-primary-10 border border-primary";

    if (hasError) return "h-10 w-full bg-white border border-alert-red";
    return "h-10 w-full bg-white border border-light-grey";
  };

  const getFilteredData = () => {
    if (!data?.length) return [];

    if (search && searchKey) {
      return data?.filter((item) =>
        item[searchKey]?.toLowerCase()?.includes(search?.toLowerCase()),
      );
    }

    return data;
  };

  useEffect(() => {
    let timer;
    if (open) {
      timer = setTimeout(() => {
        inputRef?.current?.focus();
      }, 0);
    }

    return () => clearTimeout(timer);
  }, [open]);

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open}
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1 max-h-[150px] overflow-y-scroll"
          style={{
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
            width: width || "328px",
          }}
        >
          <div className="">
            <input
              ref={inputRef}
              className="px-3 py-2 w-full h-10 bg-background hover:bg-background focus:bg-background outline-none border-none font-aileron text-xs font-medium leading-4.5 text-dark-gray rounded-md placeholder:font-aileron placeholder:text-dark-gray"
              placeholder={
                type === "batteries" ? "Search Batteries" : "Search Hub Station"
              }
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {getFilteredData().map((option) => {
            const selected = option.value === value;

            return (
              <button
                key={option.id}
                type="button"
                className="w-full flex items-center justify-between px-3 py-2 group hover:bg-background"
                onClick={() => {
                  onSelect(option);
                  setOpen(false);
                }}
              >
                <p className="font-aileron text-xs font-semibold capitalize whitespace-nowrap text-dark-gray group-hover:text-black">
                  {option.value}
                </p>

                {selected ? (
                  <TickIcon size={16} className="text-green" />
                ) : null}
              </button>
            );
          })}
        </div>
      }
    >
      <button
        type="button"
        className={`px-3 py-[11px] flex items-center justify-between gap-x-3 rounded-md capitalize ${getValueStyle()}`}
      >
        <p
          className={`font-poppins font-medium text-xs
          ${value ? "text-black" : "text-dark-gray"}
          `}
        >
          {value || placeholder}
        </p>

        <ChevronIcon
          className={`w-4 h-4 transform transition-all duration-[400] stroke-dark-gray  
          ${open ? "-rotate-90" : "rotate-90"}`}
        />
      </button>
    </Popover>
  );
};

export default SelectionDropdown;
